import { render, staticRenderFns } from "./target-users-tree.vue?vue&type=template&id=daf05b1c"
import script from "./target-users-tree.vue?vue&type=script&lang=js"
export * from "./target-users-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports